import { GET_PRODUCTS, GET_ALL_PRODUCTS, ADD_PAKKET_PRODUCTS, GET_ALL_PAKKETTEN, GET_PAKKETTEN } from "../actions/actionTypes"

const initialState = {
  products: [],
  allClientProducts: [],

  pakketProducts: [],
  
  allClientPakketten: [],
  pakketten: []
}

export default function(state=initialState, action){
  switch(action.type){

    case GET_PRODUCTS:
      return{
        ...state,
        products: action.payload
      }

      case GET_ALL_PRODUCTS:
        return{
          ...state,
          allClientProducts: action.payload
        }
        
    case ADD_PAKKET_PRODUCTS:
      return{
        ...state,
        pakketProducts: action.payload
      }

    case GET_ALL_PAKKETTEN:
      return{
        ...state,
        allClientPakketten: action.payload
      }

    case GET_PAKKETTEN:
      return{
        ...state,
        pakketten: action.payload
      }


    default:
        return state
  }
}